import { render, staticRenderFns } from "./FavoritesAlibi.vue?vue&type=template&id=b2a0a538&scoped=true"
import script from "./FavoritesAlibi.vue?vue&type=script&lang=js"
export * from "./FavoritesAlibi.vue?vue&type=script&lang=js"
import style0 from "./FavoritesAlibi.vue?vue&type=style&index=0&id=b2a0a538&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2a0a538",
  null
  
)

export default component.exports